import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import styles from './CountryInfo.module.css';

export interface CollapsibleSectionProps {
  title: string;
  subtitle?: string | null;
  icon: React.ReactNode;
  defaultExpanded?: boolean;
  /** When false, body is always shown (no chevron). */
  collapsible?: boolean;
  children: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  subtitle,
  icon,
  defaultExpanded = false,
  collapsible = true,
  children,
}) => {
  const [open, setOpen] = useState(defaultExpanded || !collapsible);

  return (
    <section className={styles.sectionCard}>
      <button
        type="button"
        className={styles.sectionHeader}
        onClick={() => collapsible && setOpen((v) => !v)}
        disabled={!collapsible}
        aria-expanded={open}
      >
        <span className={styles.sectionIcon}>{icon}</span>
        <span className={styles.sectionTitles}>
          <h3 className={styles.sectionTitle}>{title}</h3>
          {subtitle ? <p className={styles.sectionSubtitle}>{subtitle}</p> : null}
        </span>
        {collapsible ? (
          <ChevronDown
            size={16}
            className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`}
            aria-hidden
          />
        ) : null}
      </button>
      {open ? <div className={styles.sectionBody}>{children}</div> : null}
    </section>
  );
};

export default CollapsibleSection;
